export const GATES = {
  ASK_WHY_AUTOMATION: 'ask_why_automation',
  COPY_A_SURVEY: 'copy_a_survey',
  CREATE_SURVEY_PEOPLE_GROUPS: 'create_survey_people_groups',
  GEN_REP_SAMPLE: 'gen_rep_sample',
  INSTANT_SURVEY_MAINTENANCE: 'instant_survey_maintenance',
  MAXDIFF_PREFERENCE_ANALYSIS: 'maxdiff_preference_analysis',
  QUESTION_TYPE_CONT_SUM: 'question_type_contsum',
  QUESTION_TYPE_MAX_DIFF: 'question_type_maxdiff',
  QUESTION_TYPE_NUMERIC: 'question_type_numeric',
  QUESTION_TYPE_VIDEO: 'video_survey',
  RESEARCH_OBJECTIVES: 'research_objectives',
  STANDARD_SURVEY: 'standard_survey',
  SURVEY_TEMPLATES: 'survey_templates',
  TOP_2_BOX: 'top_2_box',
  WHOLE_SURVEY_SUMMARY: 'ai_overall_summary',
};
